var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16919 0.412109C0.523469 0.412109 0 0.951529 0 1.61692C0 2.28232 0.523469 2.82174 1.16919 2.82174V0.412109ZM22.994 2.82174C23.6397 2.82174 24.1632 2.28232 24.1632 1.61692C24.1632 0.951529 23.6397 0.412109 22.994 0.412109V2.82174ZM1.16919 6.83779C0.523469 6.83779 0 7.37722 0 8.0426C0 8.70798 0.523469 9.24742 1.16919 9.24742V6.83779ZM19.8762 9.24742C20.5219 9.24742 21.0454 8.70798 21.0454 8.0426C21.0454 7.37722 20.5219 6.83779 19.8762 6.83779V9.24742ZM1.16919 13.2635C0.523469 13.2635 0 13.8029 0 14.4683C0 15.1337 0.523469 15.6731 1.16919 15.6731V13.2635ZM12.0816 15.6731C12.7273 15.6731 13.2508 15.1337 13.2508 14.4683C13.2508 13.8029 12.7273 13.2635 12.0816 13.2635V15.6731ZM1.16919 2.82174H22.994V0.412109H1.16919V2.82174ZM1.16919 9.24742H19.8762V6.83779H1.16919V9.24742ZM1.16919 15.6731H12.0816V13.2635H1.16919V15.6731Z",
    fill: "#D33F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger_menu.acecefe657f2ea0e9eeb45307e576967.svg";
export { ForwardRef as ReactComponent };